import { TokenOption } from 'uniswap/src/components/lists/items/types'
import { UniverseChainId } from 'uniswap/src/features/chains/types'

export function prioritizeNativeTokenOption(
  tokenOptions: TokenOption[],
  chainId: UniverseChainId | undefined,
): TokenOption[] {
  if (!chainId) {
    return tokenOptions
  }

  const nativeTokenIndex = tokenOptions.findIndex(
    (tokenOption) =>
      tokenOption.currencyInfo.currency.isNative && tokenOption.currencyInfo.currency.chainId === chainId,
  )

  if (nativeTokenIndex <= 0) {
    return tokenOptions
  }

  const nativeTokenOption = tokenOptions[nativeTokenIndex]
  if (!nativeTokenOption) {
    return tokenOptions
  }

  return [nativeTokenOption, ...tokenOptions.slice(0, nativeTokenIndex), ...tokenOptions.slice(nativeTokenIndex + 1)]
}
